export const initActivityTabs = (): void => {
  const tabTriggers = document.querySelectorAll<HTMLButtonElement>('.js-activity-tab-trigger');
  const tabContents = document.querySelectorAll<HTMLDivElement>('.js-activity-tab');

  // Show first tab content, hide others
  if (tabTriggers.length > 0 && tabContents.length > 0) {
    tabContents.forEach((content, index) => {
      content.style.display = index === 0 ? 'flex' : 'none';
    });
  }

  tabTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      // Update tab triggers styling
      tabTriggers.forEach((t) => {
        t.classList.remove('bg-white-1000', 'text-black-1000');
        t.classList.add('bg-black-1000', 'text-white-1000');
      });
      trigger.classList.add('bg-white-1000', 'text-black-1000');
      trigger.classList.remove('bg-black-1000', 'text-white-1000');

      // Show selected tab content, hide others
      const targetTab = trigger.getAttribute('data-tab-trigger');
      tabContents.forEach((content) => {
        if (!content.dataset.tab) return;
        content.style.display = content.dataset.tab === targetTab ? 'flex' : 'none';
      });
    });
  });
};
